@if(!isLoading){
<div class="trial-policy-card" [class.default]="policy.isDefault">
  <div class="trial-policy-card__head" [class.is-default]="policy.isDefault">
    @if (!policy.isDefault) {
    <div class="trial-policy-card__head__name">
      <label class="label">Policy Name</label>
      <span class="label-value">{{ policy.name }}</span>
    </div>
    }

    <div class="trial-policy-card__head__country">
      <span class="label-value" *ngIf="policy.isDefault">Default Policy</span>

      <div *ngIf="!policy.isDefault">
        <label class="label">Country</label>
        <span class="label-value" *ngIf="!objectHelper.isUndefinedOrNull(country)">{{policy.isDefault ? 'All Countries'
          :
          country}}</span>
      </div>
    </div>

    <div *ngIf="policy.isDefault" class="trial-policy-card__head__sites">
      &nbsp;
    </div>

    <div *ngIf="!policy.isDefault" class="trial-policy-card__head__sites">
      <label class="label">Site(s)</label>
      <span class="label-value" *ngIf="!policy.isDefault && policy.allSites">All Sites</span>
      <span class="label-value" *ngIf="policy.sites && policy.sites.length > 0">
        {{ policy.sites[0].siteNumber !== null ? policy.sites[0].siteNumber + ' ' : '' }}{{policy.sites[0].name}}
        <span *ngIf="policy.sites.length > 1"> <span class="more-light" (mouseenter)="onShowInfo()"
            (mouseleave)="onHideInfo()">+{{ policy.sites.length - 1 }} more <i
              class="far fa-angle-right"></i></span></span>
      </span>

      <div class="sites-popup" *ngIf="policy.sites.length > 0 && showSites">
        <ul>
          <li *ngFor="let site of policy.sites">
            <span class="line-1">{{site.name}}</span>
            <span class="line-2">{{site.address}} {{site.country}}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="trial-policy-card__head__actions">
      <app-button text="Remove" variant="info" size="sm" (clicked)="onRemove()"
        [visible]="authService.hasPermission(Permissions.TrialPolicyDelete) && !policy.isDefault" />

      <app-button text="Clone" variant="info" size="sm" (clicked)="onClone()"
        [visible]="authService.hasPermission(Permissions.TrialPolicyEdit)" />

      <app-button text="Edit" variant="secondary" size="sm" (clicked)="onEdit()"
        [visible]="authService.hasPermission(Permissions.TrialPolicyEdit)" />
    </div>
  </div>

  <div class="trial-policy-card__body">
    <ul>
      <li [ngClass]="{'enabled': policy.allowExpenseRequests}"><i class="icon-secure" aria-hidden="true"
          title="Expense Claims {{policy.allowExpenseRequests ? 'Enabled' : 'Disabled'}}"></i></li>
      <li [ngClass]="{'enabled': policy.allowTravelRequests}"><i class="icon-cabinet" aria-hidden="true"
          title="Travel Requests  {{policy.allowTravelRequests ? 'Enabled' : 'Disabled'}}"></i></li>
    </ul>

    <div>
      <label class="label">In App Expense Categories</label>
      <span class="label-value">{{categoriesToString(policy.expenseCategories)}}</span>
    </div>

    <div>
      <label class="label">CMS Only Expense Categories</label>
      <span class="label-value">{{categoriesToString(policy.cmsOnlyCategories)}}</span>
    </div>
  </div>
</div>
}
@else{
<div class="trial-policy-card">
  <div class="trial-policy-card__head">
    <div style="width: 70%" class="trial-policy-card__head__name">
      <ngx-skeleton-loader></ngx-skeleton-loader>
    </div>

    <div style="width: 60%" class="trial-policy-card__head__country">
      <ngx-skeleton-loader></ngx-skeleton-loader>
    </div>

    <div class="trial-policy-card__head__sites">
      <ngx-skeleton-loader style="width: 50%"></ngx-skeleton-loader>
    </div>

    <div class="trial-policy-card__head__actions">
      <ngx-skeleton-loader style="width: 45px"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 45px"></ngx-skeleton-loader>
      <ngx-skeleton-loader style="width: 45px"></ngx-skeleton-loader>
    </div>
  </div>

  <div class="trial-policy-card__body-loader">
    <div style="width: 180px">
      <ngx-skeleton-loader style="width: 180px; height: 13px;"></ngx-skeleton-loader>
    </div>

    <div style="width: 200px">
      <ngx-skeleton-loader style="width: 200px; height: 13px;"></ngx-skeleton-loader>
    </div>
  </div>
</div>
}